/** Which deployment produced the request. Build-time, so it describes the build, not the user. */
export enum OraclePlatform {
  School = 'school',
  Web = 'web',
}
